export const coinFlip = (heads: string, tails: string) => {
  return Math.random() < 0.5 ? heads : tails
}
